import React, { FC } from 'react';
import { SelectProps, Select as AntdSelect } from 'antd';
import { getI18n, useTranslation } from 'react-i18next';
import { AgentApplicationStatus } from '~/types/AgentApplication';
import { AgentLeadStatus } from '~/types/AgentLead';
import { MapItemType } from '~/types/AgentMapItem';

const applicationStatus: Record<string, AgentApplicationStatus> = {
  duplicate: 'duplicate',
  draft: 'draft',
  terminated: 'terminated',
  fillingData: 'fillingData',
  rejected: 'rejected',
  screeningFailed: 'screeningFailed',
  onReview: 'onReview',
  approval: 'approval',
  onboarding: 'onboarding',
  posStage: 'posStage',
  completed: 'completed',
  hardRejected: 'hardRejected',
  screening: 'screening',
  contract: 'contract',
  payment: 'payment',
  submissionFailure: 'submissionFailure',
};

const leadStatus: Record<string, AgentLeadStatus> = {
  new: 'NEW',
  contacted: 'CONTACTED',
  terminated: 'TERMINATED',
  converted: 'CONVERTED',
};

const applicationOptions = Object.values(applicationStatus).map((value: any) => ({
  label: getI18n().t(value, { ns: 'applicationStatus' }),
  value,
  key: value,
}));

const leadOptions = Object.values(leadStatus).map((value: any) => ({
  label: getI18n().t(value, { ns: 'leadStatus' }),
  value,
  key: value,
}));

const applicationOptionsElements = applicationOptions.map(({ label, value, key }) => (
  <AntdSelect.Option key={key} value={value}>
    {label}
  </AntdSelect.Option>
));

const leadOptionsElements = leadOptions.map(({ label, value, key }) => (
  <AntdSelect.Option key={key} value={value}>
    {label}
  </AntdSelect.Option>
));

interface Props extends SelectProps<string> {
  statusType?: MapItemType;
}

const StatusSelect: FC<Props> = (props) => {
  const { statusType = MapItemType.ALL, ...rest } = props;
  const { t } = useTranslation('agent');

  return (
    <AntdSelect mode="multiple" {...rest}>
      {statusType === MapItemType.ALL ? (
        <>
          <AntdSelect.OptGroup label={t('APPLICATION')}>{applicationOptionsElements}</AntdSelect.OptGroup>
          <AntdSelect.OptGroup label={t('LEAD')}>{leadOptionsElements}</AntdSelect.OptGroup>
        </>
      ) : statusType === MapItemType.APPLICATION ? (
        applicationOptionsElements
      ) : statusType === MapItemType.LEAD ? (
        leadOptionsElements
      ) : null}
    </AntdSelect>
  );
};

export default StatusSelect;
